export const themes = {
  best: {
    package: {
      root: 'font-bold leading-one text-center',
      label: 'block font-sans text-gray-darker text-base uppercase',
      value: 'block text-turquoise text-5xl',
      longValue: 'block text-turquoise text-3xl',
    },
    thumbnail: {
      root: 'text-base flex items-center',
      label: 'font-sans text-gray-darker',
      value: 'leading-tight text-2xl underline px-1',
      longValue: 'leading-tight text-2xl underline',
    },
    instagram: {
      root: 'text-sm sm:text-base',
      label: 'font-sans',
      value: 'leading-tight text-md underline font-bold',
      longValue: 'leading-tight text-2xl underline',
    },
    ticket: {
      root: 'leading-one font-bold',
      label: 'align-top font-sans inline-block text-sm',
      value: 'border-b-2 border-current font-sans inline-block text-3xl',
      longValue: 'border-b-2 border-current font-sans inline-block text-3xl',
    },
    remote: {
      root: 'leading-one font-bold px-1 flex items-center',
      label: 'align-top font-sans inline-block text-sm pr-1 rtl:pr-1',
      value: 'font-sans inline-block text-3xl',
      longValue: 'font-sans inline-block text-3xl',
    },
    joyviewRemote: {
      root: 'leading-one font-bold px-1 flex items-center',
      label: 'align-top font-sans inline-block text-sm pr-1 rtl:pr-1',
      value: 'font-sans inline-block text-3xl',
      longValue: 'font-sans inline-block text-3xl',
    },
    compare: {
      root: 'text-base flex items-center',
      label: 'font-sans text-gray-darker',
      value: 'leading-tight text-xl md:text-2xl underline px-1',
      longValue: 'leading-tight text-2xl underline',
    },
  },
  initial: {
    package: {
      root: 'block font-bold leading-tight text-center',
      label: 'inline-block font-sans text-gray-darker text-base',
      value: 'inline-block line-through text-gray-darker text-base',
      longValue: 'block line-through text-gray-darker text-base',
    },
    thumbnail: {
      root: 'inline-block lowercase text-md',
      label: 'hidden',
      value: 'line-through',
      longValue: 'line-through',
    },
    ticket: {
      root: 'font-bold text-sm',
      label: 'font-sans',
      value: 'font-sans line-through',
      longValue: 'font-sans line-through',
    },
    remote: {
      root: 'font-bold text-md text-grenadine',
      label: 'font-sans',
      value: 'font-sans line-through',
      longValue: 'font-sans line-through',
    },
    joyviewRemote: {
      root: 'font-bold text-md text-grenadine',
      label: 'font-sans',
      value: 'font-sans line-through',
      longValue: 'font-sans line-through',
    },
    instagram: {
      root: 'text-sm sm:text-base',
      label: 'font-sans',
      value: 'font-sans line-through',
      longValue: 'font-sans line-through',
    },
    compare: {
      root: 'inline-block lowercase text-md',
      label: 'hidden',
      value: 'line-through',
      longValue: 'line-through',
    },
  },
};
